<fading-router-outlet class="rv-root"></fading-router-outlet>
<update-modal *ngIf="_.isVisible"></update-modal>
<rivvy-outlet></rivvy-outlet>
<modal-outlet></modal-outlet>
<deprecated-callout-outlet></deprecated-callout-outlet>
<riv-overlay-outlet></riv-overlay-outlet>
<toast-outlet></toast-outlet>
<dirty></dirty>
<unsaved-changes-outlet></unsaved-changes-outlet>
